import { Col, Container, Row } from "react-bootstrap";
import React from "react";
import BgImg from "../../images/home-update/cta-2.webp";
import { Link } from "gatsby";

function Bigideascta() {
  return (
    <section className="great-product-cta big-ideas-cta p-100 text_white">
      <Container className="h-100">
        <div
          className="great-cta-products"
          style={{
            backgroundImage: `url(${BgImg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <Row className="h-100 align-items-center">
            <Col xs={12} md={10} lg={6} xl={5} xxl={5} className="">
              <h2>
                Big Ideas Deserve More Than <span>Execution</span>
              </h2>
              <p>
                At TekRevol, we don’t just build apps—we build movements. Let’s
                turn your idea into something powerful, scalable, and
                unforgettable.
              </p>
              <Link
                style={{ background: "#f47a14", color: "#fff" }}
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Start the Revolution Today!
              </Link>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Bigideascta;
